<markant-platform-ui-page-header>
  {{ 'audit.title' | transloco | concat: ' - ' : entityName }}
</markant-platform-ui-page-header>

@if (tableParams$ | async; as tableParams) {
  @if (filter) {
    <markant-filter-group
      class="toolbar"
      [excludeSearchbar]="true"
      [clearText]="'common.clearAll' | transloco"
      (filter)="onResetFilters($event.detail)"
    >
      <markant-searchbar
        placeholder="{{ 'audit.table.filter.searchPlaceholder' | transloco }}"
        [value]="tableParams.searchQuery"
        [debounce]="300"
        (valueChange)="onSearchChange($event.detail)"
      >
      </markant-searchbar>
      @for (group of filter | keyvalue: keepOrder; track group.key) {
        <markant-filter-select
          data-cy="audit-table-filter-select"
          [name]="group.key"
          [apply]="'common.apply' | transloco"
          [reset]="'common.reset' | transloco"
          [searchbar]="group.value.filterOptions.length > 6"
          [representation]="
            group.value.translationKey | defaultValue | transloco
          "
          [appliedFilters]="tableParams.activeFilter[group.key] || []"
          [options]="
            group.value.searchedFilterOptions
              ? group.value.searchedFilterOptions
              : group.value.filterOptions
          "
          (filterChange)="onFilterGroupChange($event.detail, group.key)"
          (searchbarValueChange)="
            onSearchbarValueChange($event.detail, group.value)
          "
        >
        </markant-filter-select>
      }
    </markant-filter-group>
  }

  <markant-platform-table
    class="table"
    [data]="tableData$ | async"
    [defaultHeaderCells]="tableDraft.headerAndTableCells"
    [loading]="(isLoading$ | async) ?? false"
    [stickyHeader]="true"
    [showPagination]="false"
  ></markant-platform-table>

  <markant-button
    *ngIf="hasNextPage"
    class="flex-centered"
    id="audit-load-more"
    data-cy="audit-load-more"
    colorScheme="primary"
    variant="clear"
    (click)="loadFurtherData()"
  >
    {{ 'common.loadMore' | transloco }}
  </markant-button>
}
